import React, { Component } from "react";
import { TextField, withStyles } from "@material-ui/core";
import { connect } from "react-redux";
import ReactLoading from "react-loading";
import Axios from "axios";
import SnackBar from "@material-ui/core/Snackbar";
import MuiAlert from "@material-ui/lab/Alert";

import { login, authorLogin } from "../../../redux/action/action";
import { url } from "../../../config/config";
import { useStyles } from "./EmailConfirmation.css";

class EmailConfirmation extends Component {
  constructor(props) {
    super(props);
    this.state = {
      recievedCode: "",
      success: "",
      pinError: "",
      error: true,
      notificationOpen: false,
      errorNotificationOpen: false,
      loading: true,
    };
  }

  handleNotificationOpen = () => {
    this.setState({
      notificationOpen: true,
    });
  };

  handleNotificationClose = () => {
    this.setState({
      notificationOpen: false,
      errorNotificationOpen: false,
    });
  };

  handleErrorNotificationOpen = () => {
    this.setState({
      errorNotificationOpen: true,
    });
  };

  showNotification = (severity, message) => {
    return (
      <SnackBar
        anchorOrigin={{ vertical: "top", horizontal: "right" }}
        open={this.state.notificationOpen || this.state.errorNotificationOpen}
        onClose={this.handleNotificationClose}
        style={{ top: 80 }}
        autoHideDuration={3600}
      >
        <MuiAlert
          onClose={this.handleNotificationClose}
          severity={severity}
          elevation={6}
          variant="filled"
        >
          {message}
        </MuiAlert>
      </SnackBar>
    );
  };

  checkError = (PinError) => {
    let pinError = PinError;
    if (pinError) {
      this.setState({
        pinError,
      });
      return true;
    } else {
      this.setState({
        pinError: "",
      });
      return false;
    }
  };

  handleConfirm = async (e) => {
    e.preventDefault();
    let errorStatus = this.checkError();
    this.setState({ error: errorStatus });
    if (errorStatus === false) {
      if (this.props.isAuth) {
        const response = await Axios.post(
          `${url}/api/email/verify`,
          { pin: this.state.recievedCode },
          {
            headers: { "x-auth-token": this.props.userToken },
          }
        );
        if (response.data.error) {
          this.checkError(response.data.error);
          this.setState({ error: true });
        } else {
          if (response.data.token && errorStatus === false) {
            this.setState({ success: response.data.success });
            this.props.login(response.data.token);
            this.props.history.push("/profile");
          }
        }
      }
      if (this.props.isAuthor) {
        const response2 = await Axios.post(
          `${url}/api/email/author/verify`,
          { pin: this.state.recievedCode },
          {
            headers: { "x-auth-token": this.props.authorToken },
          }
        );
        if (response2.data.error) {
          this.checkError(response2.data.error);
          this.setState({ error: true });
        } else {
          if (response2.data.token && errorStatus === false) {
            this.setState({ success: response2.data.success });
            this.props.authorLogin(response2.data.token);
            this.props.history.push("/profile");
          }
        }
      }
    }
  };

  resendEmail = async () => {
    this.handleNotificationOpen();
    if (this.props.isAuth) {
      const response = await Axios.post(
        `${url}/api/email/verificationEmail`,
        null,
        {
          headers: { "x-auth-token": this.props.userToken },
        }
      );
      if (response.data.success) {
        this.setState({
          loading: false,
        });
      }
    }
    if (this.props.isAuthor) {
      const response2 = await Axios.post(
        `${url}/api/email/author/verificationEmail`,
        null,
        {
          headers: { "x-auth-token": this.props.authorToken },
        }
      );
      if (response2.data.success) {
        this.setState({
          loading: false,
        });
      }
    }
  };

  render() {
    const { classes } = this.props;
    return (
      <div>
        {(this.state.notificationOpen === true ||
          this.state.loading === true) &&
        this.state.loading === true
          ? this.showNotification("info", "Loading...")
          : this.showNotification("success", "Email Successfully Sent.")}
        <form className={classes.formStyle}>
          We have send a confirmation mail to your email address.
          <TextField
            name="recievedCode"
            type="string"
            required
            variant="outlined"
            margin="normal"
            placeholder="Enter code recieved"
            style={{ width: "50%", outline: "none" }}
            error={this.state.pinError ? true : false}
            helperText={this.state.pinError}
            InputProps={{
              classes: {
                root: classes.inputRoot,
                notchedOutline: classes.notchedOutline,
                focused: classes.focused,
              },
            }}
            InputLabelProps={{
              classes: {
                root: classes.labelRoot,
                focused: classes.labelFocused,
              },
            }}
            value={this.state.recievedCode}
            onChange={(e) => this.setState({ recievedCode: e.target.value })}
          />
          {this.state.code}
          <div style={{ padding: 10 }}>
            <label
              className={classes.labelStyle}
              style={{ marginRight: 10 }}
              onClick={this.handleConfirm}
            >
              Confirm
            </label>
            <label className={classes.labelStyle} onClick={this.resendEmail}>
              Resend Mail
            </label>
          </div>
          {!this.state.success && this.state.error === false && (
            <div className={classes.messageLoading}>
              <div>Verifying</div>
              <div>
                <ReactLoading type={"bubbles"} color="black" />
              </div>
            </div>
          )}
        </form>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    isAuth: state.UserReducer.isAuth,
    userToken: state.UserReducer.token,
    isAuthor: state.AuthorReducer.isAuthor,
    authorToken: state.AuthorReducer.authorToken,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    login: (userToken) => {
      dispatch(login(userToken));
    },
    authorLogin: (authorToken) => {
      dispatch(authorLogin(authorToken));
    },
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withStyles(useStyles)(EmailConfirmation));
